import cciSkuMapping from '../constants/cciSkuMapping.json';

const buildIndex = (mapping) => {
  const index = {};
  for (const entry of mapping) {
    const { nodeType, ssdCapacityTb, nicVariant, nicCards } = entry;
    if (!index[nodeType]) index[nodeType] = {};
    if (!index[nodeType][ssdCapacityTb]) index[nodeType][ssdCapacityTb] = {};
    if (!index[nodeType][ssdCapacityTb][nicVariant]) index[nodeType][ssdCapacityTb][nicVariant] = {};
    index[nodeType][ssdCapacityTb][nicVariant][nicCards] = entry;
  }
  return index;
};

const cciIndex = buildIndex(cciSkuMapping);

export function lookupCciSku(nodeType, ssdCapacityTb, nicVariant, nicCards) {
  return cciIndex[nodeType]?.[ssdCapacityTb]?.[nicVariant]?.[nicCards] ?? null;
}
